/*
 * File: MainDrawerPatientLink.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the patient link in the nav bar
 */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import PeopleIcon from "@material-ui/icons/People";
import PropTypes from "prop-types";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";

const PatientNav = [
  {
    title: "Patient Home",
    path: "/patient_home"
  },
  {
    title: "Demographics",
    path: "/demographics"
  },
  {
    title: "Insurance & Guarantors",
    path: "/insurance_and_guarantors"
  },
  {
    title: "Clinical",
    path: "/clinical"
  },
  {
    title: "Appointments & Follow-Ups",
    path: "/appointments"
  },
  {
    title: "Referrals",
    path: "/referrals"
  },
  {
    title: "Billing Order",
    path: "/new_charge"
  }
];

const useStyles = makeStyles(theme => ({
  panel: {
    border: 0,
    padding: 0,
    boxShadow: "none"
  },
  panelHeading: {
    fontSize: "1em",
    color: theme.palette.common.white,
    paddingLeft: "0"
  },
  panelIcon: {
    color: theme.palette.common.white,
    marginRight: 27
  },
  list: {
    background: theme.palette.primary.main,
    boxShadow: "none",
    width: "100%"
  },
  listItem: {
    color: theme.palette.common.white
  },
  subListItem: {
    paddingLeft: 80
  },
  listItemText: {
    color: theme.palette.common.white
  }
}));

const MainDrawerPatientLink = ({ patientId, handleDrawerToggle }) => {
  let [open, setOpen] = useState(false);
  let classes = useStyles();
  let subListItem = classes.listItem + " " + classes.subListItem;
  // patient sub nav items
  let patientNavItems = PatientNav.map((p, idx) => {
    // set the patient id to the patient sub routes
    p.linkTo = "/patients/" + patientId + p.path;
    let id = "sidebar-patient-link-" + p.path.replace("/", "");

    return (
      <Link to={p.linkTo} key={idx} id={id}>
        <ListItem button onClick={handleDrawerToggle} className={subListItem}>
          <ListItemText
            primaryTypographyProps={{ className: classes.listItemText }}
          >
            {p.title}
          </ListItemText>
        </ListItem>
      </Link>
    );
  });

  return (
    <React.Fragment>
      <ListItem
        button
        className={classes.listItem}
        onClick={() => setOpen(!open)}
      >
        <ListItemIcon className={classes.panelHeading}>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{ className: classes.listItemText }}
        >
          Patient
        </ListItemText>
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto">
        <List className={classes.list} disablePadding>
          {patientNavItems}
          <Link to="/patients" id="patient-link-deselect">
            <ListItem
              button
              onClick={handleDrawerToggle}
              className={subListItem}
            >
              <ListItemText
                primaryTypographyProps={{ className: classes.listItemText }}
              >
                Search
              </ListItemText>
            </ListItem>
          </Link>
        </List>
      </Collapse>
    </React.Fragment>
  );
};

MainDrawerPatientLink.propTypes = {
  patientId: PropTypes.string.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired
};

export default MainDrawerPatientLink;
